import { Component, inject } from '@angular/core';
import { LocationTableComponent as EpLocationTableComponent } from '@ep/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { Location } from '@shared/models';
import { LocationsApiService } from '@app/areas/merchants/services/locations.api.service';

@Component({
  selector: 'app-location-table',
  templateUrl: './location-table.component.html',
  styleUrls: ['./location-table.component.scss'],
  standalone: true,
  imports: [EpLocationTableComponent, AsyncPipe],
})
export class LocationTableComponent {
  private readonly locationsApiService = inject(LocationsApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected locations$: Observable<Location[]> = this.route.parent!.parent!.paramMap.pipe(
    map((params) => Number(params.get('merchantId'))),
    switchMap((merchantId) => this.locationsApiService.getByMerchantId(merchantId))
  );

  protected rowClick(location: Location): void {
    this.router.navigate([location.LocationId], { relativeTo: this.route });
  }
}
